import { type CheckoutSessionConfiguration } from "@/types";

/**
 * Static checkout session configuration for PPUI.
 *
 * Formerly fetched from GET /checkout/configuration. That call is removed
 * (CXO-2337) because PPUI only needs ckoHubVersion for Apple Pay validation,
 * and production/staging return a stable value for every country:
 *   cko_hub_version=v2, apple_pay_enabled=true.
 *
 * Legacy checkout still calls the endpoint; this constant is PPUI-only.
 */
export const DEFAULT_CHECKOUT_SESSION_CONFIGURATION: CheckoutSessionConfiguration =
  {
    applePayEnabled: true,
    pcidssApplePayEnabled: false,
    pcidssEnabled: false,
    ckoHubVersion: "v2",
  };
